<template>
  <div>
    {{ val }}
  </div>
</template>

<script>
import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

export default {
  name: 'SchemaFormElementConst',
  mixins: [SchemaFormElementMixin],
  created() {
    this.val = this.schema.const
  }
}
</script>
